// DS: i4.23
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const LocationPin: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M12 3a7 7 0 017 7c0 2.308-1.872 5.49-5.616 9.547l-.677.722-.017.017a1 1 0 01-1.322.05l-.092-.085-.335-.354C6.981 15.673 5 12.374 5 10a7 7 0 017-7zm0 4a3 3 0 100 6 3 3 0 000-6z"
      />
    </svg>
  </IconWrap>
);
LocationPin.displayName = 'LocationPin';

export default LocationPin;
